<template>
    <el-container>
        <el-aside width="200px">
            <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item title="LJH_BO_MASTER" name="1">
                    <div class="item">
                        <div class="circle">A</div>
                        <div class="text">BO_USER</div>
                    </div>
                    <div class="item">
                        <div class="circle">A</div>
                        <div class="text">BO_USER</div>
                    </div>
                    <div class="item">
                        <div class="circle">A</div>
                        <div class="text">BO_USER</div>
                    </div>
                    <div class="item">
                        <div class="circle">A</div>
                        <div class="text">BO_USER</div>
                    </div>
                    <div class="item">
                        <div class="circle">A</div>
                        <div class="text">BO_USER</div>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="LJH_BO_MASTER" name="1">
                    <div class="item">
                        <div class="circle">A</div>
                        <div class="text">BO_USER</div>
                    </div>
                    <div class="item">
                        <div class="circle">A</div>
                        <div class="text">BO_USER</div>
                    </div>
                    <div class="item">
                        <div class="circle">A</div>
                        <div class="text">BO_USER</div>
                    </div>
                    <div class="item">
                        <div class="circle">A</div>
                        <div class="text">BO_USER</div>
                    </div>
                    <div class="item">
                        <div class="circle">A</div>
                        <div class="text">BO_USER</div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </el-aside>
        <el-container>
            <el-main>
                <el-steps :active="active" finish-status="success">
                    <el-step title="步骤 1"></el-step>
                    <el-step title="步骤 2"></el-step>
                    <el-step title="步骤 3"></el-step>
                </el-steps>
                <el-form ref="form" :model="meta" label-width="120px" size="mini" style="text-align: left;">
                    <el-form-item label="所有者">
                        <el-input v-model="meta.ownerId"></el-input>
                    </el-form-item>
                    <el-form-item label="模块key">
                        <el-input v-model="meta.mkey"></el-input>
                    </el-form-item>
                    <el-form-item label="数据库">
                        <el-select v-model="meta.connName">
                            <el-option label="LJH_BO_Master" value="ConnBo"></el-option>
                            <el-option label="LJH_BS_Master" value="ConnBs"></el-option>
                            <el-option label="LJH_CT_Master" value="ConnCT"></el-option>
                            <el-option label="LJH_LOG_Master" value="ConnLog"></el-option>
                            <el-option label="LJH_OC_Master" value="ConnOC"></el-option>
                            <el-option label="LJH-ZZWH" value="ConnZZWH"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="生成表(多张)">
                        <el-input v-model="meta.tableNames"></el-input>
                    </el-form-item>
                    <el-form-item label="转换表(单张)">
                        <el-input v-model="meta.tableName"></el-input>
                    </el-form-item>
                </el-form>
                <div>数据同步</div>
                <el-form ref="form" :model="dataSync" label-width="120px" size="mini" style="text-align: left;">
                    <el-form-item label="来源库">
                        <el-input v-model="dataSync.sourceConnName"></el-input>
                    </el-form-item>
                    <el-form-item label="来源表">
                        <el-input v-model="dataSync.sourceTableName"></el-input>
                    </el-form-item>
                    <el-form-item label="来源SQL">
                        <el-input v-model="dataSync.sourceSelectSql"></el-input>
                    </el-form-item>
                    <el-form-item label="目标库">
                        <el-input v-model="dataSync.targetConnName"></el-input>
                    </el-form-item>
                    <el-form-item label="目标表">
                        <el-input v-model="dataSync.targetTableName"></el-input>
                    </el-form-item>
                    <el-form-item label="目标SQL">
                        <el-input v-model="dataSync.targetInsertSql"></el-input>
                    </el-form-item>
                </el-form>
                <el-row>
                    <el-button type="primary" @click="handleMapper">数据中间件</el-button>
                    <el-button type="success" @click="handleBridge">前端中间件</el-button>
                    <el-button type="info" @click="handleRes">响应字段中间件</el-button>
                    <el-button type="warning" @click="handleApi">接口中间件</el-button>
                    <el-button type="warning" @click="handleMenuUrl">导航地址</el-button>
                    <el-button type="info" @click="handleDataSync">数据同步</el-button>
                    <el-button type="success" @click="handleDataSyncS">查询语句</el-button>
                    <el-button type="success" @click="handleDataSyncI">插入语句</el-button>
                    <el-button type="success" @click="handleDataWord">word文档生成</el-button>
                </el-row>
                <el-input
                        type="textarea"
                        :rows="10"
                        placeholder="请输入内容"
                        v-model="result">
                </el-input>
                <!--:subfield="true" :defaultOpen="defaultData" :toolbarsFlag="true" :boxShadow="true"-->
                <mavonEditor v-model="value" ref="md" @imgAdd="$imgAdd" @change="changeMavon"/>

                <mavonEditor v-model="value" :defaultOpen="defaultData" :toolbarsFlag="false" :boxShadow="false"
                             :subfield="false"/>
            </el-main>

        </el-container>
    </el-container>
</template>

<script>
    import axios from "../../utils/axios";
    import {mavonEditor} from 'mavon-editor';
    import 'mavon-editor/dist/css/index.css';

    const SCHEMA = {
        type: 'object',
        title: 'vue-json-editor demo',
        properties: {
            name: {
                type: 'string',
            },
            email: {
                type: 'string',
            },
        },
    };
    export default {
        data() {
            return {
                value: `\`\`\` javascript
   {
    "success":true,
    "message":"更新成功，修改成功2条。"
}
\`\`\``,
                defaultData: "preview",
                schema: SCHEMA,
                // data
                model: {
                    name: 'Yourtion',
                },
                json: {
                    msg: 'demo of jsoneditor'
                },
                content: '',
                configs: {},

                result:
                    "",
                meta:
                    {
                        mkey: "bs-help",
                        connName:
                            "ConnBs",
                        ownerId:
                            "basis",
                        tableNames:
                            "bs_help",
                        tableName:
                            "bs_help"
                    }
                ,
                active: 0,
                activeNames: ['1'],
                dataSync: {
                    sourceConnName: "ConnWLZ",
                    sourceTableName: null,
                    sourceSelectSql: null,
                    targetConnName: "ConnCT",
                    targetTableName: null,
                    targetInsertSql: null
                }
            };
        },
        components: {
            mavonEditor
        }
        ,
        methods: {
            $imgAdd(pos, $file) {
                // 第一步.将图片上传到服务器.
                let formdata = new FormData();
                let that = this;
                formdata.append('image', $file);
                axios({
                    url: 'http://localhost:62000/bo/api/v1/file/upload',
                    method: 'post',
                    data: formdata,
                    headers: {'Content-Type': 'multipart/form-data'},
                }).then((url) => {

                    // 第二步.将返回的url替换到文本原位置![...](0) -> ![...](url)
                    /**
                     * $vm 指为mavonEditor实例，可以通过如下两种方式获取
                     * 1. 通过引入对象获取: `import {mavonEditor} from ...` 等方式引入后，`$vm`为`mavonEditor`
                     * 2. 通过$refs获取: html声明ref : `<mavon-editor ref=md ></mavon-editor>，`$vm`为 `this.$refs.md`
                     */
                    that.$refs.md.$img2Url(pos, url.data[0].url);
                })
            }
            ,

            handleChange(val) {
                console.log(val);
            }
            ,
            next() {
                if (this.active++ > 2) this.active = 0;
            },
            changeMavon() {

            }
            ,
            handleMapper() {
                let that = this;
                let a = this.$app.url.baseApi;
                axios({
                    url: this.$app.url.baseApi + "/bo/api/v1/aid/sql/config?connName=" + this.meta.connName + "&ownerId=" + this.meta.ownerId + "&tableNames=" + this.meta.tableNames,
                    method: "get"
                }).then(
                    res => {
                        that.result = JSON.stringify(res);
                    }
                );
            }
            ,
            handleBridge() {
                let that = this;
                let a = this.$app.url.baseApi;
                axios({
                    url: this.$app.url.baseApi + "/bo/api/v1/aid/bridge?connName=" + this.meta.connName + "&ownerId=" + this.meta.ownerId + "&mkey=" + this.meta.mkey,
                    method: "get"
                }).then(
                    res => {
                        that.result = JSON.stringify(res);
                    }
                );
            }
            ,
            handleApi() {
                let that = this;
                let a = this.$app.url.baseApi;
                axios({
                    url: this.$app.url.baseApi + "/bo/api/v1/aid/swagger/generator?ownerId=" + this.meta.ownerId + "&mkey=" + this.meta.mkey,
                    method: "get"
                }).then(
                    res => {
                        that.result = JSON.stringify(res);
                    }
                );
            }
            ,
            handleRes() {
                let that = this;
                let a = this.$app.url.baseApi;
                axios({
                    url: this.$app.url.baseApi + "/bo/api/v1/aid/res/field?connName=" + this.meta.connName + "&ownerId=" + this.meta.ownerId + "&tableName=" + this.meta.tableName,
                    method: "get"
                }).then(
                    res => {
                        that.result = JSON.stringify(res);
                    }
                );
            },
            handleDataSync() {
                let that = this;
                let a = this.$app.url.baseApi;
                axios({
                    url: this.$app.url.baseApi + "/bo/api/v1/db/data/sync",
                    method: "post",
                    data: that.dataSync
                }).then(
                    res => {
                        that.result = JSON.stringify(res);
                    }
                );
            },

            handleDataSyncS() {
                let that = this;
                let a = this.$app.url.baseApi;
                axios({
                    url: this.$app.url.baseApi + "/bo/api/v1/db/data/s",
                    method: "post",
                    data: that.dataSync
                }).then(
                    res => {
                        that.result = JSON.stringify(res);
                    }
                );
            },
            handleDataSyncI() {
                let that = this;
                let a = this.$app.url.baseApi;
                axios({
                    url: this.$app.url.baseApi + "/bo/api/v1/db/data/i",
                    method: "post",
                    data: that.dataSync
                }).then(
                    res => {
                        that.result = JSON.stringify(res);
                    }
                );
            },
            handleDataWord() {
                let that = this;
                let a = this.$app.url.baseApi;
                axios({
                    url: this.$app.url.baseApi + "/bo/api/v1/aid/export/word?template=ljh&ownerId=" + this.meta.ownerId + "&connName=" + this.meta.connName                    ,
                    method: "get",
                    data: that.dataSync
                }).then(
                    res => {
                        that.result = JSON.stringify(res);
                    }
                );
            },
            handleMenuUrl() {
                this.result = "/console/table-" + this.meta.mkey + "/brower";
            }
        }
    }
</script>

<style scoped="scoped" lang="scss">
    .item {
        clear: both;
        line-height: 26px;
        font-size: 14px;

    .circle {
        float: left;
        width: 24px;
        height: 24px;
        border-radius: 24px;
        margin: auto;
        background-color: red;
    }

    .text {
        float: left;
        margin-left: 10px;
    }

    }
</style>